import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function CostComparison() {
  const rows = [{
    sin: 'Redactás los boletines de memoria al cierre del período',
    costo: 'Horas de tu tiempo libre, estrés y errores que podés evitar'
  }, {
    sin: 'Usás siempre las mismas 5 frases en todos los informes',
    costo: 'Informes genéricos que no reflejan a cada alumno y debilitan tu imagen profesional'
  }, {
    sin: 'Llegás a una reunión de padres difícil sin guion ni documentación',
    costo: 'Situaciones que escalan y quedan sin registro legal'
  }, {
    sin: 'Hacés actas desde cero cada vez que las necesitás',
    costo: 'Tiempo perdido y riesgo de errores en documentación legal'
  }, {
    sin: 'No tenés un sistema de registro diario',
    costo: 'Al cierre del año no sabés exactamente qué pasó con cada alumno'
  }, {
    sin: 'Usás lenguaje coloquial en los informes',
    costo: 'Pérdida de credibilidad profesional ante directivos y familias'
  }, {
    sin: 'No sabés cómo documentar situaciones de vulnerabilidad',
    costo: 'Riesgo legal real ante situaciones que requieren protocolo'
  }, {
    sin: 'El año termina y no tenés un sistema para el siguiente',
    costo: 'Cada ciclo empezás desde cero con la misma carga administrativa'
  }];
  return <section className="py-20 bg-zinc-900 text-white" data-id="element-46">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-47">
        <div className="text-center mb-12" data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-49">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="overflow-x-auto pb-4 mb-12" data-id="element-50">
          <div className="min-w-[600px]" data-id="element-51">
            <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-52">
              <div className="font-bold text-violet-300 uppercase text-sm tracking-wider" data-id="element-53">
                Sin el MegaPack
              </div>
              <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-54">
                Costo real
              </div>
            </div>

            <div className="space-y-2" data-id="element-55">
              {rows.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 bg-black/60 rounded-xl p-4 items-center border border-violet-900/30" data-id="element-56">
                  <div className="text-zinc-100 font-medium" data-id="element-57">{row.sin}</div>
                  <div className="text-red-300 font-medium" data-id="element-58">{row.costo}</div>
                </div>)}
            </div>
          </div>
          <p className="text-center text-sm text-violet-400 mt-4 md:hidden" data-id="element-59">
            ← Scroll to see full table →
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-gradient-to-br from-violet-600 to-purple-700 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-60">
          <p className="md:text-2xl font-medium text-white mb-4 text-[16px]" data-id="element-61">
            El próximo cierre de notas puede encontrarte diferente.
          </p>
          <p className="md:text-4xl font-black text-white text-[20px]" data-id="element-62">
            "El próximo trimestre, vas a saber exactamente qué escribir en cada
            boletín y por qué." 🎓🇦🇷
          </p>
        </motion.div>
      </div>
    </section>;
}